import {Component, OnInit} from '@angular/core';
import {AuthenticationManager, ProgressIndicatorService} from '../../@shared';
import {
    ECommerceControllerService,
    HttpRequestDto,
    OrderLineDto,
    PurchaseOrderDto,
    PurchaseOrdersDto
} from '../../@api';
import {DatePipe} from '@angular/common';
import {OrdersDataService} from "./orders.data.service";

@Component({
    selector: 'secure-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

    orders: PurchaseOrderDto[] = [];

    constructor(private progressIndicatorService: ProgressIndicatorService,
                private authenticationManager: AuthenticationManager,
                private eCommerceControllerService: ECommerceControllerService,
                private datePipe: DatePipe,
                public data: OrdersDataService) {
        console.log('OrdersComponent constructor()');
        this.data.reset();
        this.data.addItemToBreadcrumbItems({label: 'My Orders', routerLink: '/secure/orders'});

        this.showProgress();
    }

    ngOnInit(): void {
        let request: HttpRequestDto = {
            id: this.authenticationManager.authenticatedUser.userDto.customerId
        };
        this.eCommerceControllerService.findCustomerOrders(request).subscribe((response: PurchaseOrdersDto): void => {
            console.log(JSON.stringify(response.orders));
            this.orders = response.orders;
            this.hideProgress(800);
        }, error => {
            console.log(error);
            this.hideProgress(300);
        });
    }

    lineStatusDesc(line: OrderLineDto, order: PurchaseOrderDto): string {
        let lineStatus: string = line.status || '';
        if (lineStatus.length === 0) {
            lineStatus = order.status;
        }
        console.log('status: ' + lineStatus);

        let lineStatusDate: Date = line.statusDate;
        if (!lineStatusDate) {
            lineStatusDate = order.createdByDate;
        }

        let lineStatusLabel: string = '';
        switch (lineStatus) {
            case 'CREATED':
            case 'ORDER_PAYMENT_PENDING': {
                lineStatusLabel = 'Awaiting payment on ' + this.datePipe.transform(lineStatusDate, 'dd MMM yyyy'); break;
            }
            case 'ORDER_PAID': {
                lineStatusLabel = 'Payment received on ' + this.datePipe.transform(lineStatusDate, 'dd MMM yyyy'); break;
            }
            case 'ORDER_SHIPPED': {
                lineStatusLabel = 'Shipped on ' + this.datePipe.transform(lineStatusDate, 'dd MMM yyyy'); break;
            }
            case 'ORDER_CANCELLED': {
                lineStatusLabel = 'Cancelled on ' + this.datePipe.transform(lineStatusDate, 'dd MMM yyyy'); break;
            }
            case 'ORDER_COMPLETE': {
                lineStatusLabel = 'Complete on ' + this.datePipe.transform(lineStatusDate, 'dd MMM yyyy'); break;
            }
        }

        return lineStatusLabel;
    }

    showProgress(): void {
        this.progressIndicatorService.publish(true);
    }

    hideProgress(delay): void {
        setTimeout((): void => {
            this.progressIndicatorService.publish(false);
        }, delay);
    }
}
